import classNames from 'classnames';
import { showToast } from 'components/Toast';
import { FC, useState } from 'react';
import { getUserStripeCustomerPortal } from 'store/user/actions';
import { IUserStripeSubscriptionData } from 'store/userStripeSubscriptions/types';
import { getIsSubscriptionActive } from '../utils';
import { RedirectModal } from './RedirectModal';

interface Props {
  pageQueryString: string;
  subscription: IUserStripeSubscriptionData;
  isMobile: boolean;
}

export const PageNameAndCancel: FC<Props> = ({ pageQueryString, subscription, isMobile }) => {
  const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [redirectPageName, setRedirectPageName] = useState('');

  const onStripeSubscriptionCancel = () => {
    setIsRedirectModalOpen(true);
    setRedirectPageName('the subscription cancellation page');
    getUserStripeCustomerPortal({
      flow_type: 'subscription_cancel',
      subscription_id: subscription.id,
      return_url: window.location.href,
    })
      .then(response => {
        if (response.data?.url) {
          setRedirectUrl(response.data.url);
          window.location.href = response.data.url;
        } else {
          setIsRedirectModalOpen(false);
          setRedirectUrl('');
          setRedirectPageName('');
          showToast(
            'Sorry, we were unable to cancel your subscription. Please try again later.',
            'error'
          );
        }
      })
      .catch(() => {
        setIsRedirectModalOpen(false);
        setRedirectUrl('');
        setRedirectPageName('');
        showToast(
          'Sorry, we were unable to cancel your subscription. Please try again later.',
          'error'
        );
      });
  };

  return (
    <>
      <div className={classNames('display-flex flex-wrap', { 'flex-direction-column': isMobile })}>
        <span className="body-small-text mr5">{subscription.page_name || pageQueryString}</span>
        {getIsSubscriptionActive(subscription) ? (
          <button
            className="button button-link color-gray text-left"
            onClick={onStripeSubscriptionCancel}
            aria-label={`Cancel ${subscription.page_name || pageQueryString} subscription`}
          >
            Cancel
          </button>
        ) : (
          <span className="body-small-text color-gray">Canceled</span>
        )}
      </div>
      <RedirectModal
        isOpen={isRedirectModalOpen}
        redirectPageName={redirectPageName}
        redirectUrl={redirectUrl}
      />
    </>
  );
};
